import { render, staticRenderFns } from "./ClientDatail.vue?vue&type=template&id=14fe59e3&scoped=true&"
import script from "./ClientDatail.vue?vue&type=script&lang=js&"
export * from "./ClientDatail.vue?vue&type=script&lang=js&"
import style0 from "./ClientDatail.vue?vue&type=style&index=0&id=14fe59e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fe59e3",
  null
  
)

export default component.exports